import React, { useEffect, useState } from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';
import './index.css'; 
import { GET_VOLUNTEER_DATA } from '../../api/volunteer.js';

const VolunteerAdminView = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(GET_VOLUNTEER_DATA)
      .then(res => {
        if (res.data && Array.isArray(res.data.data)) {
          setData(res.data.data);
        } else {
          setData([]); 
        }
      })
      .catch(err => {
        console.error("Error fetching volunteer data:", err);
        setData([]); 
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Box className="admin-view-wrapper">
      <Typography variant="h4" className="admin-header-text">Volunteer Registrations</Typography>
      
      <TableContainer component={Paper} className="table-container-paper">
        <Table>
          <TableHead className="registrations-table-head">
            <TableRow>
              <TableCell className="table-head-cell">Volunteer Name</TableCell>
              <TableCell className="table-head-cell">Profile Type</TableCell>
              <TableCell className="table-head-cell">Contact Details</TableCell>
              <TableCell className="table-head-cell">Commitment</TableCell>
              <TableCell className="table-head-cell">Motivation</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center" className="table-status-message">
                  Loading volunteer data...
                </TableCell>
              </TableRow>
            ) : data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center" className="table-status-message">
                  No volunteer registrations found.
                </TableCell>
              </TableRow>
            ) : (
              data.map((row) => (
                <TableRow key={row._id} className="table-row-item">
                  <TableCell className="table-cell-name">
                    {row.firstName} {row.lastName}<br/>
                    <small>{row.organization}</small>
                  </TableCell>
                  <TableCell>{row.userType}</TableCell>
                  <TableCell>{row.email}<br/>{row.phone}</TableCell>
                  <TableCell>{row.allottedTime} hrs ({row.city})</TableCell>
                  <TableCell className="table-cell-reason">"{row.reason}"</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default VolunteerAdminView;